import { PlayCircleIcon } from 'lucide-react';
import React, { useState } from 'react';

import { Button, HStack, Paragraph, Text, VStack } from '@eluve/components';

import { useInterstitialFlow } from '../../hooks/useInterstitialFlow';
import { InterstitialFlowProps } from '../../types';

import { VideoWalkthroughModal } from './VideoWalkthroughModal';

// Completion happens when user closes modal (after optionally watching video)

export const VideoWalkthroughSidePanel: React.FC<
  InterstitialFlowProps
> = () => {
  const { complete } = useInterstitialFlow('VIDEO_WALKTHROUGH');
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = async () => {
    setOpen(false);
    await complete();
  };

  return (
    <>
      <HStack
        wFull
        className="cursor-pointer rounded-lg border border-border-primary bg-transparent p-3"
        onClick={handleOpen}
      >
        <Button
          variant="outline"
          className="size-10 items-center rounded border-none bg-bg-tertiary"
          size="icon"
        >
          <PlayCircleIcon size={19} />
        </Button>
        <VStack gap={1} align="start" className="pl-3">
          <Text size="sm" color="primary">
            Learn how to use Eluve
          </Text>
          <Paragraph size="sm" weight="regular" color="secondary">
            Watch a 4 min video walkthrough
          </Paragraph>
        </VStack>
      </HStack>
      {open && <VideoWalkthroughModal isOpen={open} onClose={handleClose} />}
    </>
  );
};
